import {
  ColoredArabicLogoIcon,
  ColoredLogoIcon,
} from "@design-system/icons";
import { getCurrentLocaleCode, trans } from "@mongez/localization";
import { contactIrCards } from "../data";

export function ContactIrInfo() {
  const locale = getCurrentLocaleCode();
  const Logo = locale === "ar" ? ColoredArabicLogoIcon : ColoredLogoIcon;

  return (
    <section className="bg-[#f7f9fc] py-14 text-marine sm:py-16 lg:py-20">
      <div className="container">
        <div className="rounded-[2rem] bg-white px-6 py-10 shadow-sm sm:px-10 lg:px-16 lg:py-14">
          <Logo className="mb-10 h-auto w-36 sm:w-44" aria-hidden="true" />

          <div className="grid grid-cols-1 gap-10 md:grid-cols-2 md:gap-16 xl:gap-24">
            {contactIrCards.map((card) => (
              <article key={card.title} className="space-y-2">
                <h2 className="text-xl font-bold sm:text-2xl">
                  {trans(card.title)}
                </h2>
                <div className="space-y-1 text-sm font-semibold sm:text-base">
                  {card.items.map((item) => (
                    <p key={item.label} className="flex flex-wrap gap-1">
                      <span>{trans(item.label)}:</span>
                      <a
                        href={item.href}
                        dir="ltr"
                        className="transition-colors duration-300 hover:text-bright-orange hover:underline"
                      >
                        {item.value}
                      </a>
                    </p>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
